import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CurrencyFormat } from '../../pipes/currencyFormat.pipe';
import { CarrierService } from '../../services/carrier.service';
import { PopupService } from '../../services/shared/popup.service';
import { AuthWebService } from 'app/services/authweb.service';
import { accounting } from 'accounting';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from '../../services/application.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from 'environments/environment';
import { PermitService } from 'app/services/permit.service';
import { RouteService } from 'app/services/route.service';
import { Observable } from 'rxjs';
import { PermitTypeService } from 'app/services/permit-type.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

declare var $;

@Component({
  selector: 'app-permit-application',
  templateUrl: './permit-application.component.html',
  styleUrls: ['./permit-application.component.css'],
  providers: [CurrencyFormat]
})
export class PermitApplicationComponent implements OnInit {
  dataCntrl: any = { carrierID: -1, carrier: {}, applications: [], applicationtype: {} };
  pageSize: number = 10;
  pageSizeMax: number = 2147483647; // C# Int32.MaxValue
  pageNumber: number = 1;
  Count: number = 0;
  pageload: boolean;
  gridload: boolean;
  permitStatus14: any = 0;
  permitStatus13: any = 0;
  permitStatus7:any = 0;
  permitStatus6:any = 0;
  permitStatus2:any = 0;
  user
  acc: any = { link_person: '', status: '' };
  PermitStatus10:any = 0;
  message = '';
  loadCompleted: boolean = false;
  
  vehicles: any = 0;
  lineTotal: any = 0;
  totalFee: any = 0;
  chargeInd: any = 0;
  submissionAmt: any = 0;
  paidAmt: any = 0;
  dueAmt: any = 0;

  permitTypes: any = {};

  constructor(public applicationService: ApplicationService, private router: Router, private activeRoute: ActivatedRoute,private confirmDialogService: ConfirmDialogService,
    private carrierService: CarrierService, private permitTypeService: PermitTypeService, private toaster: ToastrService,
    public currformat: CurrencyFormat, public showModal: PopupService, private authWebService: AuthWebService,public utility: UtilityServiceService,private permitService: PermitService,) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
  }

  ngOnInit() {
    this.PermitStatus10 = this.authWebService.userData.Configurations.find(p => p.Code == 'PermitStatus10').Value

    //console.log(this.dataCntrl.application);
    //console.log(this.user);
    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.permitStatus14 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus14').Value;
      this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
      this.permitStatus7 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus7').Value;
      this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
      this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
    }
    this.activeRoute.params.subscribe((params: Params) => {
      this.dataCntrl.carrierID = params['id'];
      //alert(this.dataCntrl.carrierID);
    });
    this.utility.changeKey = 0;
    this.getApplications();
    this.getCarrier();
    this.loadAccounts();
    this.getPermitTypes();

  }
  navigateTo(value, list) {
    //console.log(value)
    if (value === 'myNum') {
      return this.router.navigate(['under-construction']);
    }
    if (value == 'renew') {
      this.confirmDialogService.confirmThis('Are you sure you want to renew this permit?',
        () => {
            let url: any = "carrier/permit/application/renew/" + list.id + "/" + list.carrier_id + "/" + true;
            this.router.navigate([url]);
          
        }, () =>  {  
          //No here
          $("#selectControl option[value='']").prop('selected', true);
            return false;
        })
    }

    if (value == 'view') {
      //console.log(list);
      if(list.status_id == 74)
      {
        let url: any = '/carrier/compliance/return/list/' + list.carrier_id + "/" + 0 + '/' + true + '/' + list.id;
        this.router.navigate([url]);
        //this.router.navigate(['/carrier/compliance/application'] ,{ queryParams: { id:list.carrier_id,appID:list.id, compID:item.id,typeId:list.permit_type_id} });
      }
      else{
       // localStorage.setItem('permitNum',list.number_of_permits);
        this.router.navigate(['/carrier/permit/application/view', list.id]);
      }
    }

    if (value == 'edit') {
      let PermitStatus2 = this.authWebService.userData.Configurations.find(c => c.Code == "PermitStatus2").Value
      if (list.status_id < PermitStatus2 || list.status_id == this.permitStatus13 || list.status_id == PermitStatus2) {
        this.router.navigate(['/carrier/permit/application/edit', list.id]);
      }
      else {
        this.toaster.warning("You may only edit an application that has not been submitted. You can try unsubmit the application.", "");
      }
    }

    if (value == 'delete') {
      this.deleteApplication(list);
    }

    if (value == "unsubmit") {
      //console.log(list);
      let PermitStatus10 = this.authWebService.userData.Configurations.find(c => c.Code == "PermitStatus10").Value
      let permStatusesIsLess = true;
      list.permits.forEach(element => {
        if (element.status_id >= PermitStatus10)
          permStatusesIsLess = false;
      });
      if ((list.permits.length == 1 && list.permits[0].status_id < PermitStatus10) || list.status_id < PermitStatus10 && permStatusesIsLess) {
        // this.showModal.showYesNo('Unsubmit Application', 'Are you sure you wish to unsubmit the application?', `If you have paid any fees they will be credited to your account and you can use the credit to pay for another application.`, 'Yes', 'No')
        //   .subscribe((isConfirmed) => {
        //     if (isConfirmed) {
        //       this.gridload = true;              
        //       this.applicationService.UnsubmitApp(list.id, 3).subscribe(data => {
        //         this.toaster.success("Your application " + list.id + " has been unsubmitted. You can edit it and resubmit it at any time. If you have already been invoiced, your account has been credited and you can use these funds to pay for another permit application.", "");
        //         this.gridload = false;
        //         this.getApplications();
        //         this.getCarrier();
        //         this.loadAccounts();
        //       });
        //     } else {
        //       return;
        //     }
        //   });
          this.confirmDialogService.confirmThis("Are you sure you wish to unsubmit the application? If you have paid any fees they will be credited to your account and you can use the credit to pay for another application.", () => {  
          
            this.gridload = true;              
            this.applicationService.UnsubmitApp(list.id, 3).subscribe(data => {
              this.toaster.success("Your application " + list.id + " has been unsubmitted. You can edit it and resubmit it at any time. If you have already been invoiced, your account has been credited and you can use these funds to pay for another permit application.", "");
              this.gridload = false;
              this.getApplications();
              this.getCarrier();
              this.loadAccounts();
            });
      
          }, () =>  {  
            return;
          })
      } else {
        this.toaster.warning("You may not unsubmit an application where the permit has been printed or if the application consists of many permits and payment has been made. You can try and unsubmit the individual permit applications from the permits list screen.", "");
      }
    }

    if(value == "confirm"){
       console.dir(list.permits);
       //console.log(list.permits.length)
       if(list.permits.length == 1)
       {

        if(list.permits[0].status_id< this.permitStatus13)
        {
          this.toaster.warning("Permit must have been approved before you can confirm the details");
          return;
        }


        if(list.permits[0].status_id> this.permitStatus7)
        {
          this.toaster.warning("Permit has already been processed and you cannot change it");
          return;
        }


        this.router.navigate(['/carrier/permit/application/view/'+ list.permits[0].id + '/' +  2]);
       }
       if(list.permits.length > 1)
       {
        this.toaster.warning("This application contains more than one permit. Please select the permit on the Permits list screen");
        return;
       }
    }
    if (value == 'cancelApp') {
      this.cancelApplication(list);
    }

    if(value == "completepayment"){
      if (this.sufficientFunds(list) == true) {
        localStorage.setItem('oldAppId',list.id);
        this.router.navigate(['/carrier/permit/application/change/'+ list.id +'/completepayment']);
      }
      else {
        this.toaster.warning(`The account balance on this carrier account is insuffecient to complete payment on this appliation. Please try again after the account balance has been increased.`, `Insuffecient Funds`);
        $("#selectControl option[value='']").prop('selected', true);
        return;
      }
    }
    return false;
  }

  getApplications() {
    var thisCarrier = this.dataCntrl;
    this.gridload = true;
    this.loadCompleted = false;
    this.carrierService.getCarrierApplications(this.dataCntrl.carrierID, this.pageNumber, this.pageSize).subscribe(result => {
      this.setApplicationData(result);
    }, error => {
      this.gridload = false;
      this.loadCompleted = true;
    });
  }

  viewAcc(list, url) {
    if (list.status == 'AccountStatus3') {
      this.toaster.error('Your Carrier account has not been approved');
      return false;
    } else {
      this.router.navigate([url, list.carrierID]);
    }
  }

  setApplicationData(data) {
    let numPermits: any;
    data.Items.forEach(element => {
      element.total_fees = this.formatCurrency(element.total_fees);
      
      if (element.number_of_permits > 1) {
        if(element.status_id == 74)
        {
          numPermits = element.vehicle.filter(x => x != null && x.permit != null && x.permit.status_id == 74);
        }
        else
        {
          numPermits = element.vehicle.filter(x => x != null);
        }
        if (numPermits.length > 0) {
          element.number_of_permits = numPermits.length;
        } else {
          element.number_of_permits = 1;
        }
      }
    });
    this.Count = data.Count
    this.dataCntrl.applications = data.Items
    //console.log(data.Items);
    this.gridload = false;
    this.loadCompleted = true;
  }
  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }
  getCarrier() {
    this.pageload = true;
    this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
      this.setCarrierData(result);
      //console.log(result)
      this.pageload = false;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }

  setCarrierData(data) {
    if (data.account_balance != 0) {
      data.account_balance = -(parseFloat(data.account_balance));
    }
    data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
    this.dataCntrl.carrier = data;
    //console.log(this.dataCntrl.carrier);
  }
  loadAccounts() {
    if (this.user) {
      this.carrierService.listCarrierAccountsByUserId(this.user.Id).subscribe((result:any) => {
        //console.log(result.find(x => x.id == this.dataCntrl.carrierID))
        this.acc = result.find(x => x.id == this.dataCntrl.carrierID);
        if (this.acc.account_balance != 0) {
          this.acc.account_balance = -(parseFloat(this.acc.account_balance));
        }
        this.acc.account_balance = this.formatCurrency(this.acc.account_balance)

      }, error => {

      })
    }
  }

  getPermitTypes(){
    this.permitTypeService.getAll().subscribe(result => {
      this.permitTypes = result;
    });
  }

  onBack() {
    this.router.navigateByUrl('/carrier/accounts');
  }

  editApplication(id) {
    this.showModal.showAlert('Edit Application', 'This feature will be available in release 2');
  }

  viewApplication(id) {
    this.router.navigateByUrl(`/carrier/permit/edit/${id}/false`); //false to just the application
  }

  onPage(page) {
    this.pageNumber = page
    this.getApplications();
    return page;
  }

  pageSizeName(value) {
    if (value === this.pageSizeMax) return 'All';
    return value;
  }

  pageSizes() {
    return [5, 10, 25, 50, 100, 500, this.pageSizeMax];
  }

  pageSizeChange() {
    this.getApplications();
  }
  cancelApplication(item){
    //console.log(item)
    // this.showModal.showYesNo('Cancel Permit', 'Are you sure that you want to cancel your application. If your application fee has been paid you cannot get it refunded. If your permit fee has been paid, you must contact us to apply for a refund.', ``, 'Yes', 'No')
    // .subscribe((isConfirmed) => {

    //   if (isConfirmed) {
    //     this.showModal.showYesNo('Confirm', 'You are about to cancel your permit. Press Yes to continue and cancel the permit.', ``, 'Yes', 'No')
    // .subscribe((isConfirmed) => {

    //   if (isConfirmed) {

    //    if(item.permits.length === 1){
    //     this.message = 'Processing your request, please wait...!';
    //     this.gridload = true;
    //     this.permitService.UpdatePermitStatus(item.permits[0].id).subscribe(data => {
    //       if (data === true) {
    //         this.toaster.success('The permit was cancelled successfully');
    //         this.getApplications();
    //         this.getCarrier();
    //         this.loadAccounts();

    //       } else {

    //         // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
    //       }
    //      // this.gridload = false;

    //     }, error => {
    //       this.gridload = false;
    //       this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

    //     })
    //    }
    //    else{
    //      this.toaster.info('This application contains more than one permit. Please select the permit on the Permits list screen.')
    //      this.router.navigateByUrl(`/carrier/permit/application/cancel/permit/${item.carrier_id}/${item.id}`);
    //    }


    //   } else {
    //     return false;
    //   }
    // });

    //   } else {
    //     return false;
    //   }
    // });
    this.confirmDialogService.confirmThis("Are you sure that you want to cancel your application? If your application fee has been paid you cannot get it refunded. If your permit fee has been paid, you must contact us to apply for a refund.", () => {  
          
      this.confirmDialogService.confirmThis("You are about to cancel your permit. Press Yes to continue and cancel the permit.", () => {  
          
        if(item.permits.length === 1){
          this.message = 'Processing your request, please wait...!';
          this.gridload = true;
          this.permitService.UpdatePermitStatus(item.permits[0].id).subscribe(data => {
            if (data === true) {
              this.toaster.success('The permit was cancelled successfully');
              this.getApplications();
              this.getCarrier();
              this.loadAccounts();
  
            } else {
  
              // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
            }
           // this.gridload = false;
  
          }, error => {
            this.gridload = false;
            this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");
  
          })
         }
         else{
           this.toaster.info('This application contains more than one permit. Please select the permit on the Permits list screen.')
           this.router.navigateByUrl(`/carrier/permit/application/cancel/permit/${item.carrier_id}/${item.id}`);
         }
      
      }, () =>  {  
        return false;
      })
      
    }, () =>  {  
      return false;
    })
  }

 deleteApplication(applicationData)
  {
    if (applicationData.id == undefined || applicationData.id == null) {
      this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    } else {
      this.confirmDialogService.confirmThis('Are you sure you want to delete application no ' + applicationData.id + '?', () => {  
          
          this.message = 'Processing your request, please wait...';
          this.gridload = true;

          console.log("delete application");

          // applicationData.permits.forEach(permit => {
          //   this.deletePermits(permit.id)
          // });
          // setTimeout(() => {
            
          // }, 8000);
          this.deleteApp(applicationData.id);

        
      
      }, () =>  {  
        //No here
      }) 
      // this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete application no ' + applicationData.id + '?', `You're about to delete application`, 'Yes', 'No').subscribe((isConfirmed) => {
      //     if (isConfirmed) {
      //       this.message = 'Processing your request, please wait...';
      //       this.gridload = true;

      //       console.log("delete application");

      //       // applicationData.permits.forEach(permit => {
      //       //   this.deletePermits(permit.id)
      //       // });
      //       // setTimeout(() => {
              
      //       // }, 8000);
      //       this.deleteApp(applicationData.id);

      //     }
      //     else {
      //         return;
      //     }
      // });
    }
  }




  deletePermits(id) {
    this.pageload = true;
      this.permitService.deletePermit(id).subscribe(x => {  });
  }

  deleteApp(id){ 
    this.applicationService.deleteApplication(id).subscribe(x =>
    {
      if (x != null) {
        this.gridload = false;
        this.toaster.clear();
        this.toaster.success('The Permit Application was deleted successfully.', 'Delete Application');
        this.refreshPage()
        setTimeout(() => {
          this.toaster.clear();
          //clearTimeout();
        }, 2500);
      }
      else {
        setTimeout(() => {        
         console.log('retry delete application');
        }, 8000);
      }
    }
    , error =>
    {
      this.gridload = false;
      console.log(JSON.stringify(error));
      this.toaster.error(error.status + " - " + error.statusText, 'SYSTEM ERROR! (Application delete)');
      
      this.getApplications();
    });
  }

  deleteAppAgain(id) {
      this.applicationService.deleteApplication(id).subscribe(x => {
        if (typeof(x) == 'object') {
          this.toaster.success('The Permit Application was deleted successfully.', 'Delete Application');
          this.refreshPage()

          setTimeout(() => {
            this.toaster.clear();
           // clearTimeout();
            this.gridload = false;
          }, 2500);

        } else {
          this.gridload = false;
          this.toaster.error('There was a problem deleting the Permit Application. If the problem persists, please contact the system administrator.');
          let newRouterLink = '/carrier/permit/application/' + this.dataCntrl.carrierID;
          this.router.navigate(['/']).then(() => { this.router.navigate([newRouterLink]); });
        }
      });
    }

  refreshPage() {
    if (this.dataCntrl.applications.length > 1) {
      this.getApplications();
    }
    else {
      let newRouterLink = '/carrier/permit/application/' + this.dataCntrl.carrierID;
      this.router.navigate(['/']).then(() => { this.router.navigate([newRouterLink]); });
    }
  }

  sufficientFunds(appl) : boolean {
    this.getDueAmount(appl);
    let acntBal: any = 0;
    
    if (this.dataCntrl['carrier'].account_balance != null) {
      acntBal = (this.dataCntrl['carrier'].account_balance).toString().replace(/\s+/g, "");
      acntBal = acntBal.replace("R", "");
    }
    
    if (acntBal < this.dueAmt){
      return false;
    } else {
      return true;
    }    
  }

  getDueAmount(application) {

    // let application = applic.;
    let prmtType = this.permitTypes.find(x => x.id = application.permit_type_id && x.charge_when_ind != 0);

    if (application != undefined) {

      let applFee = application['permits'][0].application_fee;
      let prmtFee = application['permits'][0].permit_fee;

      this.vehicles = application.vehicle
      this.dueAmt = 0;
      this.submissionAmt = 0;

      if (this.vehicles == null || this.vehicles == undefined) {
        application.vehicles = [];
      }
      this.totalFee = (applFee + prmtFee) * application.vehicle.length;
      if (this.vehicles == null || this.vehicles.length == 0) {
        this.totalFee = applFee;
      }
      if (this.vehicles == null || this.vehicles.length == 0) {
        this.submissionAmt = applFee;
      }

      this.chargeInd = prmtType.charge_when_ind;

      if (this.chargeInd == 1 && this.vehicles.length > 0) {
        this.submissionAmt = (applFee) * this.vehicles.length;
        this.dueAmt = this.submissionAmt - this.paidAmt;
      }
      if (this.chargeInd == 2 && this.vehicles.length > 0) {
        this.submissionAmt = (applFee) * this.vehicles.length + (prmtFee) * this.vehicles.length;
        this.dueAmt = this.submissionAmt - this.paidAmt;
      }
    }
  }

}
